import FullPageLoader2 from 'Components/FullPageLoader2/FullPageLoader2';
import React from 'react';


const FullPageLoader = ({ allowFullScreen }) => <FullPageLoader2 allowFullScreen={allowFullScreen} />

export default FullPageLoader